import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { TextField } from "@material-ui/core";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import ReportByGame from "../ReportByGame";
import _ from "lodash";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ParlayTeaserExposure() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <ReportByGame
        title="Parlay Teaser Exposure Report"
        groupBy="idSport"
        getPostProcess={(groupedData) => {
          const items = Object.values(groupedData).map((Values) => {
            const [{ idGame, idSport, sportOrder, gameDate }] = Values;

            return {
              idGame,
              idSport,
              sportOrder,
              gameDate: new Date(gameDate),
              IsNested: true,
              Values: Values.map((item) => ({
                Values: [item],
              })),
            };
          });

          return _.sortBy(items, ["sportOrder", "gameDate", "idGame"]);
        }}
        getGroupTitle={({ idSport }) => (
          <h3>{idSport?.trim()?.toUpperCase()}</h3>
        )}
        getUrl={() => "/Reports/Report_Parlay_Teaser_Exposure_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          LineType: lineType,
          Office: office,
          Group: group,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
        })}
        getProcess={(_, values) => {
          const {
            Id,
            gameDate,
            visitor,
            home,
            parlayVisitorSide,
            parlayHomeSide,
            parlayVisitorTotal,
            parlayHomeTotal,
            teaserVisitorSide,
            teaserHomeSide,
            teaserVisitorTotal,
            teaserHomeTotal,
          } = values?.[0];
          return [
            {
              Id: `${Id}V`,
              date: gameDate,
              team: visitor,
              parlaySides: parlayVisitorSide,
              parlayTotal: parlayVisitorTotal,
              teaserSides: teaserVisitorSide,
              teaserTotal: teaserVisitorTotal,
            },
            {
              Id: `${Id}H`,
              date: "",
              team: home,
              parlaySides: parlayHomeSide,
              parlayTotal: parlayHomeTotal,
              teaserSides: teaserHomeSide,
              teaserTotal: teaserHomeTotal,
            },
          ];
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="date"
          dataFormat={dateTimeReportFormatter}
        >
          Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="team">
          Game
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="parlaySides">
          P-Sides
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="parlayTotal">
          P-Total
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="teaserSides">
          T-Sides
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="teaserTotal">
          T-Total
        </TableHeaderColumn>
      </ReportByGame>
    </div>
  );
}

export default ParlayTeaserExposure;
